<script setup lang="ts">
/**
 * HLOS-137 — ConversationState (wrapper).
 *
 * **HLOS-6:** state canônico de conversation. Após HLOS-137/138, vira um
 * **wrapper** que seleciona entre ConversationInit (boot) e ConversationChat
 * (UI) baseado em `phase` (singleton via `useConversationPhase`).
 *
 * Comportamento idêntico ao ConversationState monolítico original (300 linhas).
 * Testids preservados (zero breaking change em App.spec.ts).
 *
 * **Ref:** HLOS-138 (arquitetura), HLOS-137 (AC-2 strict < 50 LOC).
 */
import ConversationInit from "../../conversation/components/ConversationInit.vue";
import ConversationChat from "../../conversation/components/ConversationChat.vue";
import { useConversationPhase } from "../../conversation/composables/useConversationPhase";

const emit = defineEmits<{
  (e: "end"): void;
}>();

const phase = useConversationPhase();

/** Propaga 'end' do filho para o App.vue (state machine). */
function onEnd(): void {
  emit("end");
}
</script>

<template>
  <section
    class="hlos-conversation"
    data-testid="conversation-state"
    data-state="conversation"
  >
    <ConversationInit
      v-if="phase.phase.value !== 'chat'"
      @end="onEnd"
    />
    <ConversationChat
      v-else
      @end="onEnd"
    />
  </section>
</template>
